import { Component, OnInit } from '@angular/core';
import { AlertService } from '../../../../core/services/alert.service';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilderService } from '../../../../core/services/formBuilder.service';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { NoticeModel, OutcomeQuestionnaireModel } from '../../../../models/notices/noticeModel';
import { switchMap } from 'rxjs/operators';

@Component({
  selector: 'app-notices',
  templateUrl: './notices.component.html',
  styleUrls: ['./notices.component.scss'],
  standalone: false
})
export class NoticesComponent implements OnInit {
  modalOptions: NgbModalOptions;
  currentModal: any;
  
  noticeComponent: boolean = false;
  noticesExist: boolean;
  loadingDoc = false;
  unacknowledgedNoticesExist: boolean = false;
  showAllNotices: boolean = false;
  showNoticeSection: boolean = false;
  public loginNotices: NoticeModel[];
  url: string | null = null;
  innerHtmlString: string | null = null;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private formBuilderService: FormBuilderService,
    private modalService: NgbModal,
    private alertService: AlertService,
  ) { 
    if (this.router.url === "/notices"){
      this.noticeComponent = true;
    }
    else{
      this.noticeComponent = false;
    }
  }

  ngOnInit() {
    this.route.parent.paramMap.pipe(switchMap((parentParams: ParamMap) => {
      return this.formBuilderService.getLoginNotices(this.showAllNotices);
    })).subscribe(notices => {
      if(notices != null && notices.length > 0){
        this.loginNotices = notices;
        this.noticesExist = true;
        this.unacknowledgedNoticesExist = notices.some(x => x.acknowledgedDate == null);
      }
    }, error => {});
    this.modalOptions = {
      keyboard: false,
      backdrop: "static",
      windowClass: 'my-class'
    };
  }

  ngOnDestroy() {
    this.cleanup();
  }

  private cleanup(): void {
    if (this.url) {
      URL.revokeObjectURL(this.url);
      this.url = null;
    }
    this.innerHtmlString = null;
  }

  openNotice(content: any, notice: NoticeModel){
    if (notice.acknowledgedDate == null){
      this.alertService.confirm("Confirm", "By opening this notice you acknowledge that you have recieved it and will read it in it's entirety.").subscribe(answer => {
        if (answer) {          
          this.getNotice(notice, content);
        }
      });
    }
    else{
      this.getNotice(notice, content);
    }
  }

  getNotice(notice: NoticeModel, content: any) {
    if (!notice) { return; }
    if (notice.formSubmissionId != null) {
      this.getFormSubmissionNotice(notice, content);
    }
    else {
      this.getOutcomeQuestionnaire(notice, content);
    }
  }

  getOutcomeQuestionnaire(notice: NoticeModel, content: any) {
    if (notice?.outcomeQuestionnaireId != null) {
      this.loadingDoc = true;
      this.formBuilderService.getOutcomeQuestionnaireHtml(notice.outcomeQuestionnaireId).subscribe({
        next: (oQ: OutcomeQuestionnaireModel) => {
          this.innerHtmlString = oQ.templateHtml;
          this.loadingDoc = false;
        },
        error: (err) => {
          console.error('Failed to load HTML:', err);
          this.loadingDoc = false;
        }
      });
      this.currentModal = this.modalService.open(content, this.modalOptions);
    }
  }

  getFormSubmissionNotice(notice: NoticeModel, content: any) {
    if (notice?.formSubmissionId != null) {
      this.loadingDoc = true;
      this.formBuilderService.getFormSubmissionDocToSign(notice.formSubmissionId).subscribe({
        next: (arrayBuffer: any) => {
          this.url = URL.createObjectURL(new Blob([arrayBuffer], {
            type: 'application/pdf'
            }));
          this.loadingDoc = false;
        },
        error: (err) => {
          this.innerHtmlString = 'Failed to Load PDF';//err; //err is arrayBuffer
          console.error('Failed to load PDF:', err);
          this.loadingDoc = false;
        }
      });
      this.currentModal = this.modalService.open(content, this.modalOptions);
    }
  }  
    
  getAcknowledgedColor(acknowledgedDate: null){
    if(acknowledgedDate == null){
      return "text-danger";
    }
    else{
      return "text-success";
    }
  }

  closeNoticeModal(){
    this.getLoginNotices(this.showAllNotices)
    this.currentModal.close();
    this.cleanup();
  }

  getLoginNotices(showAll: boolean){
    this.route.parent.paramMap.pipe(switchMap((parentParams: ParamMap) => {
      return this.formBuilderService.getLoginNotices(showAll);
    })).subscribe(notices => {
      if(notices != null && notices.length > 0){
        this.loginNotices = notices;
        this.noticesExist = true;
        this.unacknowledgedNoticesExist = notices.some(x => x.acknowledgedDate == null);
      }
      else{
        this.loginNotices = [];
      }
    }, error => {});
  }

  dismissNotice(notice: NoticeModel){
    if (notice.formSubmissionId > 0 && notice.acknowledgedDate == null){
      this.alertService.error("Please view the notice before dismissing");
      return;
    }
    if (notice.formSubmissionId > 0) {
      this.route.parent.paramMap.pipe(switchMap((parentParams: ParamMap) => {
        return this.formBuilderService.dismissNotice(notice.formSubmissionId);
      })).subscribe(notice => {
        if (notice) {
          this.alertService.success("Notice Dismissed")
          this.getLoginNotices(this.showAllNotices);
        }
      }, error => { });
    }
    else if (notice.outcomeQuestionnaireId > 0) {
      this.formBuilderService.dismissOutcomeQuestionnaire(notice.outcomeQuestionnaireId).subscribe(() => {
        this.alertService.success("Notice Dismissed");
        this.getLoginNotices(this.showAllNotices);
      }, error => {
        this.alertService.error("Error dismissing notice: " + error);
      });
    }
    else {
      this.alertService.error("Unable to dismiss notice. Please try again or contact support if the issue persists.");
    }
  }

  doToggleShowAllNotices(){
    if(this.showAllNotices == true){
      this.showAllNotices = false;
    }
    else{
      this.showAllNotices = true
    }

    this.getLoginNotices(this.showAllNotices);
  }

  getHeightForPDF() {
    if (window.innerHeight > 600) {
      return (window.innerHeight - 248) + 'px';
    } else {
      return '450px';
    }
  }
}
